import locationQuestions from './questions/location';
import postcodeQuestions from './questions/postcode';

const quickOnboardingQuestions = [...locationQuestions, ...postcodeQuestions];

export default quickOnboardingQuestions;
